import React from 'react';
import classnames from 'classnames';
import { template } from '@iyunbao/cr-engine';

import { clearObj } from '../../utils/tools';

export interface TplProps {
  prefixCls?: string;
  value?: {
    [propName: string]: any;
  };
  label: string;
  className?: string;
  style?: React.CSSProperties;
}

const Tpl = (props: TplProps) => {
  const {
    prefixCls = 'crm-tpl',
    value,
    label,
    className,
    style,
  } = props;

  if (!label) {
    return null;
  }

  const cls = classnames(prefixCls, className);
  const tplProps = clearObj({
    style,
  });

  return <div className={cls} {...tplProps}>{template(label, value)}</div>;
};

export default Tpl;
